import { Payee } from '@root/api/ump-catalog-manager'
import { PayeeWithCustomParamsType, TspPageDenomination, TspPagePayee } from '../model/tsp.types'
import { omitUndefined } from './omitUndefined'

const pickPayeeUsedFields = (payee: PayeeWithCustomParamsType): TspPagePayee =>
  omitUndefined({
    serviceId: payee.serviceId,
    providerName: payee.providerName,
    icon: payee.icon,
    params: payee.params?.map((param) =>
      omitUndefined({
        name: param.name,
        hidden: param.hidden,
        title: param.title,
        description: param.description,
        displayOrder: param.displayOrder,
        regExp: param.regExp,
      })
    ),
    features: omitUndefined({
      tsp_url: payee.features?.tsp_url as string | undefined,
      tsp_picture_web: payee.features?.tsp_picture_web as string | undefined,
      category_web: payee.features?.category_web as string | undefined,
      backgroundcategory: payee.features?.backgroundcategory as string | undefined,
      textAbovePayButton: payee.features?.textAbovePayButton as string | undefined,
    }),
    customParams: omitUndefined({
      isDisabled: payee.customParams?.isDisabled,
      isWithPercentFee: payee.customParams?.isWithPercentFee,
      isZeroFee: payee.customParams?.isZeroFee,
    }),
  })

const PRICE_PARAM_NAMES = new Set(['partnerId', 'serviceCode'])

const pickDenominationUsedFields = (denomination: Payee): TspPageDenomination =>
  omitUndefined({
    serviceId: denomination.serviceId,
    params: denomination.params
      ?.filter((param) => PRICE_PARAM_NAMES.has(param.name))
      .map((param) =>
        omitUndefined({
          name: param.name,
          defaultValue: param.defaultValue,
        })
      ),
    features: omitUndefined({
      country_web: denomination.features?.country_web as string | undefined,
      buttonLabel: denomination.features?.buttonLabel as string | undefined,
      buttonIcon: denomination.features?.buttonIcon as string | undefined,
      iconsubcategory: denomination.features?.iconsubcategory as string | undefined,
      colorsubcategory: denomination.features?.colorsubcategory as string | undefined,
      subcategory: denomination.features?.subcategory as string | undefined,
    }),
  })

export const omitUnusedTspPageFields = (
  payee: PayeeWithCustomParamsType,
  denominationsByCountry: Record<string, Payee[]>
): { payee: TspPagePayee; denominationsByCountry: Record<string, TspPageDenomination[]> } => ({
  payee: pickPayeeUsedFields(payee),
  denominationsByCountry: Object.fromEntries(
    Object.entries(denominationsByCountry).map(([country, denominations]) => [
      country,
      denominations.map(pickDenominationUsedFields),
    ])
  ),
})
